import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";

export const ActiveButton = ({ className }: { className?: string }) => (
  <Button
    variant="secondary"
    disabled
    className={classNames("flex items-center gap-x-2", className)}
  >
    <Icon type="check" viewBox="0 0 16 16" />
    {t("profile_drawer.connect_banner.states.active")}
  </Button>
);
